module.exports = __webpack_public_path__ + "img/Cas9variants_ALL.c480def6.svg";